<div class="live-chart-wrapper">
  <div id="live-chart-background"></div>

  <svg id="live-chart" xmlns="http://www.w3.org/2000/svg" version="1.1"
       viewBox="-30 0 400 230">
    <!-- Generator: Adobe Illustrator 29.3.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 151)  -->
    <defs>
      <style>
        .st0, .st1, .st2, .st3, .st4 {
          fill: none;
        }

        .st5 {
          fill: #fbba00;
        }

        .st6 {
          fill: #d9d9d9;
        }

        .st7, .st8 {
          fill: #71b451;
        }

        .st9, .st10 {
          stroke-width: .2px;
        }

        .st9, .st10, .st11 {
          fill: #fff;
        }

        .st9, .st10, .st4 {
          stroke: #fff;
        }

        .st10 {
          stroke-miterlimit: 10;
        }

        .st12 {
          fill: #00b6ee;
        }

        .st8 {
          fill-opacity: .7;
        }

        .st1 {
          stroke: url(#green-gradient);
          stroke-width: 3px;
          fill: none;
          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw-inverted 3s linear infinite;
        }


        .st2 {
          stroke: url(#yellow-gradient-vertical);
          stroke-width: 3px;
          fill: none;
          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw 3s linear infinite;
        }

        .st16 {
          stroke: url(#blue-gradient);
          stroke-width: 3px;
          fill: none;
          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw 3s linear infinite;
        }


        .st3 {
          stroke: #000;
        }

        .st13 {
          stroke: url(#black-gradient);
          stroke-width: 3px;
          fill: none;
          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw-inverted 3s linear infinite;
        }

        .st14 {
          stroke: url(#black-gradient2);
          stroke-width: 3px;
          fill: none;
          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw-inverted 3s linear infinite;
        }

        .st15 {
          stroke: url(#yellow-gradient);
          stroke-width: 3px;
          fill: none;

          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw 3s linear infinite;
        }

        .st17 {
          stroke: url(#blue-black-gradient);
          stroke-width: 3px;
          fill: none;

          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw 3s linear infinite;
        }

        .st18 {
          stroke: url(#green-black-gradient);
          stroke-width: 3px;
          fill: none;

          stroke-dasharray: 300;
          stroke-dashoffset: 0;
          animation: stroke-draw 3s linear infinite;
        }


        @keyframes stroke-draw {
          0% {
            stroke-dashoffset: 300;
          }
          50% {
            stroke-dashoffset: 0;
          }
          100% {
            stroke-dashoffset: -300;
          }
        }

        @keyframes stroke-draw-inverted {
          0% {
            stroke-dashoffset: -300;
          }
          50% {
            stroke-dashoffset: 0;
          }
          100% {
            stroke-dashoffset: 300;
          }
        }


        .st15-background, .st2-background {
          stroke: #fbba00;
          stroke-width: 3px;
          fill: none;
        }

        .st3-background {
          stroke: #333333;
          stroke-width: 3px;
          fill: none;
        }

        .st1-background, .st18-background {
          stroke: #71b451;
          stroke-width: 4px;
          fill: none;
        }

        .st16-background, .st17-background {
          stroke: #00b6ee;
          stroke-width: 4px;
          fill: none;
        }

        .net-background-black {
          fill: var( --color-grid-black);
        }

      </style>

      <!-- gradient farbcodes -->
      <linearGradient id="yellow-gradient" data-name="yellow-gradient" x1="166.4" y1="90.8" x2="261.8" y2="90.8"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#FFE49F" />
        <stop offset="1" stop-color="#fbba00 " />
      </linearGradient>

      <linearGradient id="black-gradient" data-name="black-gradient" x1="92.95" y1="124.84" x2="240.6" y2="124.84"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#8d8e92" />
        <stop offset="1" stop-color="#1d1d1b" />
      </linearGradient>

      <linearGradient id="black-gradient2" data-name="black-gradient" x1="92.95" y1="124.84" x2="240.6" y2="124.84"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#E1E1E1FF" />
        <stop offset="1" stop-color="#60605FFF" />
      </linearGradient>

      <linearGradient id="yellow-gradient-vertical" data-name="yellow-gradient-vertical" x1="167.5" y1="158" x2="167.5"
                      y2="51" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#FFE49F" />
        <stop offset="1" stop-color="#fbba00" />
      </linearGradient>

      <linearGradient id="green-gradient" data-name="green-gradient" x1="44.1" y1="151.09" x2="126.2" y2="151.09"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#CDE4C1" />
        <stop offset="1" stop-color="#83BE68" />
      </linearGradient>

      <linearGradient id="green-black-gradient" data-name="green-black-gradient" x1="176.97" y1="149.59" x2="279.9"
                      y2="149.59" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#96d96b" />
        <stop offset=".39" stop-color="#94d76a" />
        <stop offset=".53" stop-color="#90d067" />
        <stop offset=".64" stop-color="#88c462" />
        <stop offset=".72" stop-color="#7db35a" />
        <stop offset=".79" stop-color="#6f9d51" />
        <stop offset=".85" stop-color="#5d8145" />
        <stop offset=".91" stop-color="#486138" />
        <stop offset=".96" stop-color="#313c28" />
        <stop offset="1" stop-color="#1d1d1b" />
      </linearGradient>

      <linearGradient id="blue-gradient" data-name="blue-gradient" x1="44.1" y1="151.09" x2="126.2" y2="151.09"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#85E6FF" />
        <stop offset="1" stop-color="#71b451" />
      </linearGradient>

      <linearGradient id="blue-black-gradient" data-name="blue-black-gradient" x1="92.95" y1="124.64" x2="240.6"
                      y2="124.64" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#84E4F7" />
        <stop offset=".38" stop-color="#00b4ec" />
        <stop offset=".52" stop-color="#01afe5" />
        <stop offset=".62" stop-color="#02a7d9" />
        <stop offset=".7" stop-color="#059ac8" />
        <stop offset=".77" stop-color="#088ab2" />
        <stop offset=".83" stop-color="#0b7696" />
        <stop offset=".89" stop-color="#105f76" />
        <stop offset=".94" stop-color="#154350" />
        <stop offset=".99" stop-color="#1b2527" />
        <stop offset="1" stop-color="#1d1d1b" />
      </linearGradient>

    </defs>

    <!-- line -5 -->
    <path class="st18-background line-battery-net-green-background" d="M177,189.4c86.3-.9,99.5,5.7,99.9-82.2" />
    <path class="st18 line-battery-net-green" d="M177,189.4c86.3-.9,99.5,5.7,99.9-82.2" />

    <!-- line 5  -->
    <path class="st3-background line-net-battery-black-background" d="M177,189.4c86.3-.9,99.5,5.7,99.9-82.2" />
    <path class="st14 line-net-battery-black" d="M177,189.4c86.3-.9,99.5,5.7,99.9-82.2" />

    <!-- Line -4 -->
    <path class="st1-background line-battery-consumption-green-background" d="M47.1,113.4c.4,60.1-3.8,75.2,79,72.5" />
    <path class="st1 line-battery-consumption-green" d="M47.1,113.4c.4,60.1-3.8,75.2,79,72.5" />

    <!-- Line 4 -->
    <path class="st16-background line-consumption-battery-blue-background" d="M47.1,113.4c.4,60.1-3.8,75.2,79,72.5" />
    <path class="st16 line-consumption-battery-blue" d="M47.1,113.4c.4,60.1-3.8,75.2,79,72.5" />

    <a routerLink="/energy-chart" fragment="battery">
    <rect class="st6 battery-bg-grey" x="99.2" y="152.2" width="89.8" height="64" rx="4" ry="4" />
    </a>
    <path class="st8 battery-soc-light-green" d="M102.7,152.2 h56.4v64h-56.4c-2.2,0-4-1.8-4-4v-56c0-2.2,1.8-4,4-4Z" />


    <!-- line 6-->
    <path class="st3-background line-grid-consumption-black-background" d="M93,108.2c83.1-1.1,37.6,33.3,147.6,33.3" />
    <path class="st13 line-grid-consumption-black" d="M93,108.2c83.1-1.1,37.6,33.3,147.6,33.3" />

    <!-- line -6 (inverted)-->
    <path class="st17-background line-consumption-grid-blue-background" d="M93,108.2c83.1-1.1,37.6,33.3,147.6,33.3" />
    <path class="st17 line-consumption-grid-blue" d="M93,108.2c83.1-1.1,37.6,33.3,147.6,33.3" />


    <!-- Line 3 -->
    <path class="st15-background line-production-net-yellow-background" d="M171.4,48.6c1,79.4-6,79.2,90.4,79.5" />
    <path class="st15 line-production-net-yellow" d="M171.4,48.6c1,79.4-6,79.2,90.4,79.5" />

    <!-- Line 1 -->
    <path class="st15-background line-production-consumption-yellow-background"
          d="M162,49.2c.3,52.2-10.2,50.4-86.5,49.2" /> <!-- M164,49.2c.3,52.2-10.2,50.4-86.5,49.2-->
    <path class="st15 line-production-consumption-yellow" d="M162,49.2c.3,52.2-10.2,50.4-86.5,49.2" />

    <!--<path class="st4 white-arrow" d="M115.1,93.9l3.9,4.9-3.9,4.6"/>
    <path class="st4 white-arrow" d="M145.3,101.2l-4.4-4.4,4-5.5"/>-->

    <!-- Line 2 -->
    <path class="st15-background line-production-battery-yellow-background" d="M167.5,51.2v107" />
    <path class="st15 line-production-battery-yellow" d="M167.5,51.2v107" />

    <!--<path class="st4 white-arrow" d="M166.5,111.1l1.1.9,1.1-.9"/>
    <path class="st4 white-arrow" d="M169,119.6l-1.5-1.3-1.5,1.2"/>-->

    <a routerLink="/energy-chart" fragment="grid">

      <rect class="st6 bg" x="237" y="104.2" width="91" height="64" rx="4" ry="4" />
      <path class="net-background-black" d="M237,108.2c0-2.2,1.8-4,4-4h83c2.2,0,4,1.8,4,4v19h-91v-19Z" />
      <!--<path class="st4 white-arrow" d="M84.4,182.8l-1.9,1.7,1.3,2.1"/>
      <path class="st4 white-arrow"  d="M74,185.2l1.8-1.8-1.3-2.1"/>-->

      <path class="st11 net-header-text"
            d="M274.9,120.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-7.8c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.3c.1,0,.2,0,.3,0,0,0,.1,0,.2,0,0,0,.1,0,.2.2l3.4,5.2c0,.1.2.2.2.4,0,.1.1.3.2.4h0c0-.1,0-.3,0-.4v-5.6c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v7.8c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.3c0,0-.2,0-.2,0,0,0-.1,0-.2,0,0,0,0,0-.1-.1l-3.5-5.4c0-.1-.2-.2-.2-.4,0-.1-.1-.3-.2-.4h0c0,.1,0,.3,0,.4v5.6c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2ZM285.3,120.3c-1,0-1.7-.3-2.2-.8-.5-.5-.7-1.3-.7-2.4s.1-1.3.3-1.8c.2-.5.6-.8,1-1.1.4-.2.9-.4,1.5-.4s1,.1,1.4.4c.4.2.6.6.8,1.1.2.5.3,1,.3,1.6s0,.2,0,.3c0,0-.1.2-.2.2,0,0-.1,0-.2,0h-3.6c0,.6.2,1.1.4,1.3.3.3.7.4,1.2.4s.7,0,.9-.1c.3,0,.5-.2.6-.3.2,0,.3-.1.3-.1s.1,0,.2.1c0,0,.1.2.1.3,0,.1,0,.2,0,.3s0,.2-.2.3c-.1,0-.3.2-.5.3-.2,0-.4.2-.7.2-.3,0-.5,0-.8,0ZM283.6,116.6h2.8c0-.6-.1-1-.3-1.3-.2-.3-.6-.4-1-.4s-.6,0-.8.2c-.2.1-.4.3-.5.6-.1.2-.2.6-.2.9ZM290.7,120.3c-.3,0-.6,0-.9-.2-.2-.1-.4-.3-.5-.6-.1-.2-.2-.6-.2-.9v-3.7h-.5c-.2,0-.3-.1-.3-.4v-.2c0-.3,0-.4.3-.4h.5l.2-1.2c0-.1,0-.2.1-.2,0,0,.2,0,.3,0h.2c.2,0,.3,0,.4,0s.1.1.1.2v1.2h.9c.2,0,.3.1.3.4v.2c0,.3,0,.4-.3.4h-.9v3.7c0,.2,0,.4.1.5,0,0,.2.1.4.1s.3,0,.4,0c0,0,.1,0,.2,0s0,0,.1,0c0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,.2-.2.2-.1,0-.2.1-.4.2-.2,0-.3,0-.5,0ZM292.6,120.2c0,0-.1,0-.2-.1,0,0,0-.2-.1-.3,0-.1,0-.2,0-.3s0,0,0-.1c0,0,0,0,0-.2l3.6-4.8.3.5h-3.6c-.2,0-.3-.1-.3-.4v-.2c0-.3,0-.4.3-.4h4.2c0,0,.1,0,.2.1,0,0,.1.2.1.3,0,.1,0,.2,0,.3s0,0,0,.1c0,0,0,0,0,.2l-3.6,4.8-.3-.5h3.8c.2,0,.3.1.3.4v.2c0,.3,0,.4-.3.4h-4.4Z" />

      <text x="268" y="155.2" id="net-value" font-size="18px" fill="black">17</text>
      <text x="288" y="155.2" id="net-kw" font-size="10px" fill="black">kW</text>
    </a>

    <a class="batterylink" routerLink="/energy-chart" fragment="battery">
      <path class="st7 battery-header-green" d="M99,156.2c0-2.2,1.8-4,4-4h82c2.2,0,4,1.8,4,4v19h-90v-19Z" />
      <path class="st9"
            d="M113.9,171.2h7.2c.2,0,.4-.2.4-.4v-12.9c0-.2-.2-.4-.4-.4h-7.2c-.2,0-.4.2-.4.4v12.9c0,.2.2.4.4.4ZM120.7,158.3v12.2h-6.5v-12.2h6.5Z" />
      <path class="st9"
            d="M116,158.3h2.9c.2,0,.3-.2.3-.4v-1.3c0-.2-.2-.4-.3-.4h-2.9c-.2,0-.3.2-.3.4v1.3c0,.2.2.4.3.4ZM118.6,156.9v.6h-2.2v-.6h2.2Z" />

      <text x="129" y="210" id="battery-value" font-size="18px" fill="black">15</text>
      <text id="battery-value-kw" x="150" y="210" font-size="11px" fill="black">kW</text>


      <text x="132.6" y="188.3" id="battery-soc-val" font-size="13px" fill="black"></text>
      <text id="battery-soc-percent" x="157" y="188.3" font-size="13px" fill="black">%</text>

      <path class="st11 battery-header-text"
            d="M129.7,168.2c-.3,0-.4-.1-.4-.4v-7.6c0-.3.1-.4.4-.4h2.2c.6,0,1.1,0,1.5.3.4.2.7.4.9.7.2.3.3.7.3,1.1s0,.5-.2.8c-.1.3-.3.5-.5.7-.2.2-.4.3-.6.4h0c.3.1.6.3.9.5.2.2.4.4.6.7.1.3.2.6.2.9,0,.5-.1,1-.4,1.4-.2.4-.6.6-1,.8-.5.2-1,.3-1.7.3h-2.2ZM130.6,167.1h1.6c.5,0,.8-.1,1.1-.3.3-.2.4-.6.4-1s-.1-.7-.4-1c-.3-.2-.7-.3-1.2-.3h-1.4v2.6ZM130.6,163.4h1.2c.4,0,.8-.1,1.1-.4.3-.2.4-.5.4-.9s-.1-.7-.4-.9c-.2-.2-.6-.3-1.2-.3h-1.2v2.5ZM137.6,168.3c-.6,0-1.1-.2-1.4-.5-.4-.3-.5-.8-.5-1.3s0-.7.2-1,.3-.5.6-.7c.3-.2.7-.3,1.2-.4.5,0,1.1-.1,1.9-.1v-.5c0-.2,0-.3-.1-.5,0-.1-.2-.2-.4-.3-.2,0-.4-.1-.7-.1s-.6,0-.9.1c-.3,0-.5.1-.6.2-.2,0-.3.1-.3.1s0,0-.1,0c0,0,0-.1-.1-.2,0,0,0-.2,0-.2,0,0,0-.1,0-.2,0,0,0-.2.2-.2.1,0,.3-.2.5-.2.2,0,.5-.1.8-.2.3,0,.6,0,.8,0,.4,0,.7,0,1,.1.3,0,.5.2.7.4.2.2.3.4.4.6.1.2.2.5.2.8v2.6c0,.4,0,.6,0,.9,0,.2,0,.4,0,.5,0,.1,0,.2,0,.3s0,0,0,.1c0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0s-.2,0-.2,0c0,0,0-.2-.1-.3,0-.1,0-.3,0-.5-.1.1-.3.3-.4.4-.2.1-.4.3-.6.3-.2,0-.5.1-.9.1ZM137.8,167.3c.2,0,.5,0,.7-.1.2,0,.4-.2.5-.3.2-.1.3-.3.4-.4v-1.2c-.5,0-.9,0-1.2,0-.3,0-.6.1-.8.2-.2,0-.3.2-.4.4,0,.1-.1.3-.1.5s0,.5.2.6c.2.1.4.2.7.2ZM144.1,168.3c-.3,0-.6,0-.9-.2-.2-.1-.4-.3-.5-.6-.1-.2-.2-.6-.2-.9v-3.7h-.5c-.2,0-.3-.1-.3-.4v-.2c0-.3,0-.4.3-.4h.5l.2-1.2c0-.1,0-.2.1-.2s.2,0,.3,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v1.2h.9c.2,0,.3.1.3.4v.2c0,.3,0,.4-.3.4h-.9v3.7c0,.2,0,.4.1.5,0,0,.2.1.4.1s.3,0,.4,0c0,0,.1,0,.2,0s0,0,.1,0c0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,.2-.2.2-.1,0-.2.1-.4.2-.2,0-.3,0-.5,0ZM148,168.3c-.3,0-.6,0-.9-.2-.2-.1-.4-.3-.5-.6-.1-.2-.2-.6-.2-.9v-3.7h-.5c-.2,0-.3-.1-.3-.4v-.2c0-.3,0-.4.3-.4h.5l.2-1.2c0-.1,0-.2.1-.2,0,0,.2,0,.3,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v1.2h.9c.2,0,.3.1.3.4v.2c0,.3,0,.4-.3.4h-.9v3.7c0,.2,0,.4.1.5,0,0,.2.1.4.1s.3,0,.4,0c0,0,.1,0,.2,0s0,0,.1,0c0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,.2-.2.2-.1,0-.2.1-.4.2-.2,0-.3,0-.5,0ZM152.5,168.3c-1,0-1.7-.3-2.2-.8-.5-.5-.7-1.3-.7-2.4s.1-1.3.3-1.8c.2-.5.6-.8,1-1.1.4-.2.9-.4,1.5-.4s1,.1,1.4.4c.4.2.6.6.8,1.1.2.5.3,1,.3,1.6s0,.2,0,.3c0,0-.1.2-.2.2,0,0-.1,0-.2,0h-3.6c0,.6.2,1.1.4,1.3.3.3.7.4,1.2.4s.7,0,.9-.1c.3,0,.5-.2.6-.3.2,0,.3-.1.3-.1s.1,0,.2.1c0,0,0,.2.1.3,0,.1,0,.2,0,.3s0,.2-.2.3c-.1,0-.3.2-.5.3-.2,0-.4.2-.7.2-.3,0-.5,0-.8,0ZM150.9,164.6h2.8c0-.6-.1-1-.3-1.3-.2-.3-.6-.4-1-.4s-.6,0-.8.2c-.2.1-.4.3-.5.6-.1.2-.2.6-.2.9ZM156.8,168.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4.1c0-.3,0-.6,0-.8,0-.2,0-.4,0-.5,0-.1,0-.2,0-.3s0,0,0-.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0s.1,0,.2,0c0,0,0,.1.1.3,0,.1,0,.3.1.5.1-.2.2-.4.4-.5.2-.1.3-.3.5-.3s.4-.1.6-.1.3,0,.3.1.1.2.1.3,0,.2,0,.3c0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0-.1,0s-.1,0-.2,0c0,0-.2,0-.4,0-.2,0-.5,0-.6.2-.2.1-.3.3-.4.5v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.1ZM160.9,168.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-5.7c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v5.7c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2ZM161,161.2c-.2,0-.4,0-.5,0,0,0-.1-.1-.1-.2v-.8c0,0,0-.2.1-.2,0,0,.3,0,.5,0s.4,0,.5,0c0,0,.1.1.1.2v.8c0,0,0,.2-.1.2,0,0-.3,0-.5,0ZM165.9,168.3c-1,0-1.7-.3-2.2-.8-.5-.5-.7-1.3-.7-2.4s.1-1.3.3-1.8c.2-.5.6-.8,1-1.1.4-.2.9-.4,1.5-.4s1,.1,1.4.4c.4.2.6.6.8,1.1.2.5.3,1,.3,1.6s0,.2,0,.3c0,0-.1.2-.2.2,0,0-.1,0-.2,0h-3.6c0,.6.2,1.1.4,1.3.3.3.7.4,1.2.4s.7,0,.9-.1c.3,0,.5-.2.6-.3.2,0,.3-.1.3-.1s.1,0,.2.1c0,0,0,.2.1.3,0,.1,0,.2,0,.3s0,.2-.2.3c-.1,0-.3.2-.5.3-.2,0-.4.2-.7.2-.3,0-.5,0-.8,0ZM164.2,164.6h2.8c0-.6-.1-1-.3-1.3-.2-.3-.6-.4-1-.4s-.6,0-.8.2c-.2.1-.4.3-.5.6-.1.2-.2.6-.2.9Z" />
    </a>

    <a routerLink="/energy-chart">
      <rect class="st6 production-bg-grey" x="133" y=".2" width="104" height="64" rx="4" ry="4" />
      <text x="170" y="52" id="production-value" font-size="18px" fill="black">17</text>
      <text x="190" y="52" id="production-kw" font-size="10px" fill="black">kW</text>

      <path class="st5 production-header-yellow" d="M133,4.2c0-2.2,1.8-4,4-4h96c2.2,0,4,1.8,4,4v19h-104V4.2Z" />
      <path class="st11 production-text"
            d="M164.6,16.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-7.7c0-.3.1-.4.4-.4h2.4c.9,0,1.6.2,2.1.6.5.4.7,1,.7,1.8s-.2,1.4-.7,1.9c-.5.4-1.2.6-2.1.6h-1.5v3.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2ZM165.4,11.7h1.5c.5,0,.9-.1,1.1-.3.2-.2.3-.6.3-1.1s-.1-.8-.3-1c-.2-.2-.6-.3-1.1-.3h-1.5v2.7ZM171.2,16.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4.1c0-.3,0-.6,0-.8,0-.2,0-.4,0-.5,0-.1,0-.2,0-.3s0,0,0-.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0s.1,0,.2,0c0,0,0,.1.1.3,0,.1,0,.3.1.5.1-.2.2-.4.4-.5.2-.1.3-.3.5-.3.2,0,.4-.1.6-.1s.3,0,.3.1c0,0,.1.2.1.3s0,.2,0,.3c0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0-.1,0s-.1,0-.2,0c0,0-.2,0-.4,0-.2,0-.5,0-.6.2-.2.1-.3.3-.4.5v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.1ZM177,16.3c-.9,0-1.6-.3-2.1-.8-.5-.6-.7-1.3-.7-2.4s.2-1.8.7-2.4c.5-.6,1.2-.8,2.1-.8s1.6.3,2.1.8c.5.6.7,1.4.7,2.4s-.2,1.8-.7,2.4c-.5.5-1.2.8-2.1.8ZM177,15.3c.5,0,.9-.2,1.2-.5.2-.4.4-.9.4-1.7s-.1-1.3-.4-1.7c-.2-.4-.6-.6-1.2-.6s-.9.2-1.2.5c-.2.4-.4.9-.4,1.7s.1,1.3.4,1.7c.2.4.6.5,1.2.5ZM183,16.3c-.5,0-.9-.1-1.2-.4-.3-.2-.6-.6-.8-1.1-.2-.5-.3-1.1-.3-1.7s0-1.2.3-1.7c.2-.5.5-.9.8-1.2.4-.3.8-.4,1.2-.4s.6,0,.9.2c.3,0,.5.2.7.4v-2.9c0-.1,0-.2.1-.2,0,0,.2,0,.4,0h.1c.2,0,.3,0,.4,0,0,0,.1.1.1.2v6.8c0,.3,0,.6,0,.8,0,.2,0,.4,0,.5,0,.1,0,.2,0,.3s0,.1-.1.1c0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.2,0s-.1,0-.2,0c0,0,0-.1-.1-.3,0-.1,0-.3-.1-.5-.1.2-.3.3-.5.5-.2.1-.4.2-.6.3-.2,0-.4.1-.6.1ZM183.4,15.3c.2,0,.5,0,.7-.2.2-.2.4-.3.6-.6v-3c-.2-.2-.4-.3-.7-.4-.2,0-.5-.1-.7-.1-.4,0-.7.2-1,.6-.2.4-.3.9-.3,1.6s.1,1.3.4,1.6c.2.3.6.5,1,.5ZM189.4,16.3c-.6,0-1.1-.2-1.4-.5-.3-.3-.5-.8-.5-1.4v-4.2c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v4c0,.3,0,.6.3.7.2.2.4.3.8.3s.4,0,.5,0c.2,0,.3-.2.5-.3.2-.1.3-.3.4-.4v-4.2c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v4.1c0,.3,0,.6,0,.8,0,.2,0,.4,0,.5,0,.1,0,.2,0,.3s0,.1-.1.1c0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.2,0s-.1,0-.2,0c0,0,0-.1-.1-.3,0-.1,0-.3-.1-.5-.1.2-.3.3-.5.5-.2.1-.4.2-.6.3-.2,0-.5.1-.7.1ZM194.7,16.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2V7.5c0-.1,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v5.1h0l2-2.5c0,0,0-.1.1-.1,0,0,.1,0,.2,0,0,0,.2,0,.3,0h.2c.2,0,.3,0,.3,0,0,0,.1,0,.1.1s0,0,0,.1,0,0-.1.2l-2.3,2.8v-.6l2.6,3.2c0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,.1-.1.1,0,0-.2,0-.4,0h-.2c-.2,0-.4,0-.5,0,0,0-.2-.1-.3-.2l-2.1-2.7h0v2.7c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2ZM201.9,16.3c-.3,0-.6,0-.9-.2-.2-.1-.4-.3-.5-.6-.1-.2-.2-.6-.2-.9v-3.7h-.5c-.2,0-.3-.1-.3-.4v-.2c0-.3,0-.4.3-.4h.5l.2-1.2c0-.1,0-.2.1-.2,0,0,.2,0,.3,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v1.2h.9c.2,0,.3.1.3.4v.2c0,.3,0,.4-.3.4h-.9v3.7c0,.2,0,.4.1.5,0,0,.2.1.4.1s.3,0,.4,0c0,0,.1,0,.2,0s0,0,.1,0c0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,.2-.2.2-.1,0-.2.1-.4.2-.2,0-.3,0-.5,0ZM204.5,16.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-5.7c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v5.7c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2ZM204.6,9.2c-.2,0-.4,0-.5,0,0,0-.1-.1-.1-.2v-.8c0,0,0-.2.1-.2,0,0,.3,0,.5,0s.4,0,.5,0c0,0,.1.1.1.2v.8c0,0,0,.2-.1.2,0,0-.3,0-.5,0ZM209.4,16.3c-.9,0-1.6-.3-2.1-.8-.5-.6-.7-1.3-.7-2.4s.2-1.8.7-2.4c.5-.6,1.2-.8,2.1-.8s1.6.3,2.1.8c.5.6.7,1.4.7,2.4s-.2,1.8-.7,2.4c-.5.5-1.2.8-2.1.8ZM209.4,15.3c.5,0,.9-.2,1.2-.5.2-.4.4-.9.4-1.7s-.1-1.3-.4-1.7c-.2-.4-.6-.6-1.2-.6s-.9.2-1.2.5c-.2.4-.4.9-.4,1.7s.1,1.3.4,1.7c.2.4.6.5,1.2.5ZM214.1,16.3c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4.1c0-.3,0-.6,0-.8,0-.2,0-.4,0-.5,0-.1,0-.2,0-.3s0,0,0-.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0s.1,0,.2,0c0,0,0,.1.1.3,0,.1,0,.3.1.5.1-.2.3-.3.5-.5.2-.1.4-.2.6-.3.2,0,.5-.1.7-.1.4,0,.8,0,1,.2.3.2.5.4.6.7.2.3.2.6.2,1.1v4.1c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4c0-.3,0-.6-.3-.8-.2-.2-.4-.3-.8-.3s-.3,0-.5,0-.3.2-.5.3-.3.3-.4.4v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2Z" />
    </a>

    <a routerLink="/energy-chart" fragment="consumption">
      <rect class="st6 verbrauch-bg-grey" y="63.3" width="97" height="64" rx="4" ry="4" />
      <path class="st12 verbrauch-header-blue" d="M0,65.2c0-2.2,1.8-4,4-4h89c2.2,0,4,1.8,4,4v19.8H0v-19.8Z" />
      <path class="st11 verbrauch-text"
            d="M33,77.4c-.2,0-.3,0-.4,0,0,0-.1,0-.2-.2l-2.8-7.8s0,0,0,0c0,0,0,0,0,0,0,0,0-.1.1-.2,0,0,.2,0,.4,0h.2c.1,0,.3,0,.3,0,0,0,.2,0,.2.2l2.3,6.9h0l2.3-6.9c0,0,0-.1.2-.2s.2,0,.3,0h.2c.2,0,.4,0,.4,0s.1,0,.1.2,0,0,0,0c0,0,0,0,0,0l-2.8,7.8c0,0,0,.1-.2.2,0,0-.2,0-.4,0h-.4ZM39.7,77.4c-1,0-1.7-.3-2.2-.8-.5-.5-.7-1.3-.7-2.4s.1-1.3.3-1.8c.2-.5.6-.8,1-1.1.4-.2.9-.4,1.5-.4s1,.1,1.4.4c.4.2.6.6.8,1.1.2.5.3,1,.3,1.6s0,.2,0,.3c0,0-.1.2-.2.2,0,0-.1,0-.2,0h-3.6c0,.6.2,1.1.4,1.3.3.3.7.4,1.2.4s.7,0,.9-.1c.3,0,.5-.2.6-.3.2,0,.3-.1.3-.1s.1,0,.2.1c0,0,0,.2.1.3,0,.1,0,.2,0,.3s0,.2-.2.3c-.1,0-.3.2-.5.3-.2,0-.4.2-.7.2s-.5,0-.8,0ZM38.1,73.7h2.8c0-.6-.1-1-.3-1.3-.2-.3-.6-.4-1-.4s-.6,0-.8.2c-.2.1-.4.3-.5.6-.1.2-.2.6-.2.9ZM44,77.4c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4.1c0-.3,0-.6,0-.8,0-.2,0-.4,0-.5,0-.1,0-.2,0-.3s0,0,0-.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0s.1,0,.2,0c0,0,0,.1.1.3,0,.1,0,.3.1.5.1-.2.2-.4.4-.5.2-.1.3-.3.5-.3.2,0,.4-.1.6-.1s.3,0,.3.1c0,0,.1.2.1.3s0,.2,0,.3c0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0-.1,0s-.1,0-.2,0c0,0-.2,0-.4,0-.2,0-.5,0-.6.2-.2.1-.3.3-.4.5v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.1ZM50.5,77.4c-.3,0-.7,0-1-.2-.3-.2-.6-.4-.8-.7,0,0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2-.2.2,0,0-.2,0-.3,0h0c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-8.4c0-.1,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v2.9c.1-.1.3-.2.4-.3.2,0,.3-.2.5-.2.2,0,.4,0,.6,0,.7,0,1.3.3,1.8.8.4.6.7,1.4.7,2.4s0,1.2-.3,1.7c-.2.5-.4.9-.8,1.1-.3.3-.7.4-1.2.4ZM50.2,76.4c.4,0,.7-.2.9-.6.2-.4.3-1,.3-1.7s-.1-1.2-.4-1.6c-.2-.4-.6-.6-1.1-.6s-.5,0-.7.1c-.2,0-.4.2-.6.3v3.1c.2.2.4.4.7.6.2.1.5.2.8.2ZM54.7,77.4c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4.1c0-.3,0-.6,0-.8,0-.2,0-.4,0-.5,0-.1,0-.2,0-.3s0,0,0-.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0s.1,0,.2,0c0,0,0,.1.1.3,0,.1,0,.3.1.5.1-.2.2-.4.4-.5.2-.1.3-.3.5-.3.2,0,.4-.1.6-.1s.3,0,.3.1c0,0,.1.2.1.3s0,.2,0,.3c0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0-.1,0s-.1,0-.2,0c0,0-.2,0-.4,0-.2,0-.5,0-.6.2-.2.1-.3.3-.4.5v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.1ZM59.6,77.4c-.6,0-1.1-.2-1.4-.5-.4-.3-.5-.8-.5-1.3s0-.7.2-1c.1-.3.3-.5.6-.7.3-.2.7-.3,1.2-.4.5,0,1.1-.1,1.9-.1v-.5c0-.2,0-.3-.1-.5,0-.1-.2-.2-.4-.3-.2,0-.4-.1-.7-.1s-.6,0-.9.1c-.3,0-.5.1-.6.2-.2,0-.3.1-.3.1s0,0-.1,0c0,0,0-.1-.1-.2,0,0,0-.2,0-.2,0,0,0-.1,0-.2,0,0,0-.2.2-.2.1,0,.3-.2.5-.2.2,0,.5-.1.8-.2.3,0,.6,0,.8,0,.4,0,.7,0,1,.1.3,0,.5.2.7.4.2.2.3.4.4.6.1.2.2.5.2.8v2.6c0,.4,0,.6,0,.9,0,.2,0,.4,0,.5,0,.1,0,.2,0,.3s0,0,0,.1c0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0s-.2,0-.2,0c0,0,0-.2-.1-.3,0-.1,0-.3,0-.5-.1.1-.3.3-.4.4-.2.1-.4.3-.6.3-.2,0-.5.1-.9.1ZM59.8,76.4c.2,0,.5,0,.7-.1.2,0,.4-.2.5-.3.2-.1.3-.3.4-.4v-1.2c-.5,0-.9,0-1.2,0s-.6.1-.8.2c-.2,0-.3.2-.4.4,0,.1-.1.3-.1.5s0,.5.2.6c.2.1.4.2.7.2ZM66.1,77.4c-.6,0-1.1-.2-1.4-.5-.3-.3-.5-.8-.5-1.4v-4.2c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v4c0,.3,0,.6.3.7.2.2.4.3.8.3s.4,0,.5,0c.2,0,.3-.2.5-.3.2-.1.3-.3.4-.4v-4.2c0,0,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v4.1c0,.3,0,.6,0,.8,0,.2,0,.4,0,.5,0,.1,0,.2,0,.3s0,.1-.1.1c0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.2,0s-.1,0-.2,0c0,0,0-.1-.1-.3,0-.1,0-.3-.1-.5-.1.2-.3.3-.5.5-.2.1-.4.2-.6.3-.2,0-.5.1-.7.1ZM73.3,77.4c-1,0-1.7-.2-2.2-.7-.5-.5-.7-1.3-.7-2.4s.2-1.9.7-2.4c.5-.6,1.2-.8,2.2-.8s.5,0,.7,0c.2,0,.4,0,.6.2.2,0,.3.1.4.2.1,0,.2.2.2.2s0,.2,0,.3c0,.1,0,.2-.1.3,0,0-.1.1-.2.1s-.2,0-.3,0c-.1,0-.3-.1-.5-.2-.2,0-.4,0-.7,0-.5,0-.9.2-1.2.6-.3.4-.4.9-.4,1.7s.1,1.3.4,1.7c.3.4.7.5,1.3.5s.5,0,.7-.1c.2,0,.4-.1.5-.2.1,0,.2-.1.3-.1s.1,0,.2.1c0,0,0,.2.1.3,0,.1,0,.2,0,.3s0,.2-.2.3c-.1,0-.3.2-.5.3-.2,0-.4.1-.6.2-.2,0-.5,0-.7,0ZM76.9,77.4c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-8.4c0-.1,0-.2.1-.2,0,0,.2,0,.4,0h.2c.2,0,.3,0,.4,0,0,0,.1.1.1.2v3.2c.1-.2.3-.3.5-.4.2-.1.4-.2.6-.3.2,0,.5-.1.7-.1.4,0,.8,0,1,.2.3.2.5.4.6.7.2.3.2.6.2,1.1v4.1c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2c-.2,0-.3,0-.4,0,0,0-.1-.1-.1-.2v-4c0-.3,0-.6-.3-.8-.2-.2-.4-.3-.8-.3s-.3,0-.5,0-.3.2-.5.3c-.1.1-.3.3-.4.4v4.2c0,0,0,.2-.1.2,0,0-.2,0-.4,0h-.2Z" />

      <text x="32" y="114" id="consumption-value" font-size="18px" fill="black">17</text>
      <text x="52" y="114" font-size="10px" id="consumption-kw" fill="black">kW</text>
    </a>

    <!--<path class="st4 white-arrow-to-net"  d="M190.3,131.9l3,7.2-5.6,5.2"/>
    <path class="st4 white-arrow-from-net" d="M216.1,147.4l-3.9-6.8,4.9-5.8"/>
    <path class="st4 white-arrow" d="M215,195l-4.5-6.4,4.4-6.3"/>
    <path class="st4 white-arrow" d="M221.1,182.2l4.3,6.5-4.5,6.2"/>
    <path class="st4 white-arrow" d="M195.6,121.1l2.5,4.3-3.5,3.3"/>
    <path class="st4 white-arrow" d="M214.1,131l-2.8-4,3.3-3.5"/>-->
    <path class="st9 production-icon"
          d="M151.5,18.6c0,0-.1,0-.2,0-.3,0-.4-.3-.4-.6v-4.2c0,0,0-.1-.1-.1h-2c-.2,0-.4-.1-.5-.3-.1-.2-.1-.4,0-.6l4.6-7.5c.1-.2.4-.3.6-.3.3,0,.4.3.4.6v4.4c0,0,0,.1.1.1h2c.2,0,.4.1.5.3.1.2.1.4,0,.6l-4.5,7.3c-.1.2-.3.3-.5.3ZM153.3,5.4s0,0,0,0l-4.6,7.5c0,0,0,.1,0,.1,0,0,0,0,0,0h2c.3,0,.6.3.6.6v4.2c0,0,0,.1,0,.1,0,0,0,0,.1,0l4.5-7.3c0,0,0-.1,0-.1,0,0,0,0,0,0h-2c-.3,0-.6-.3-.6-.6v-4.4c0,0,0-.1,0-.1,0,0,0,0,0,0Z" />
    <g class="net-icon">
      <path class="st10"
            d="M263.8,122.1c0,0-.2,0-.2-.2l-1.4-3.9s0,0,0,0v-6.1l-1.2-2.7h-.8l-1.2,2.7v6.1s0,0,0,0l-1.4,3.9c0,.1-.2.2-.3.1-.1,0-.2-.2-.1-.3l1.4-3.9v-6.1s0,0,0,0l1.3-2.9c0,0,.1-.1.2-.1h1.1c0,0,.2,0,.2.1l1.3,2.9s0,0,0,0v6.1l1.4,3.9c0,.1,0,.2-.1.3,0,0,0,0,0,0Z" />
      <path class="st10"
            d="M266,115.1c-.1,0-.2-.1-.2-.2v-.9l-3.3-2h-.7s-2.2,0-2.2,0h-.7s-3.3,2-3.3,2v.9c0,.1-.1.2-.2.2s-.2-.1-.2-.2v-1c0,0,0-.2.1-.2l3.5-2.1s0,0,.1,0h.7s0,0,0,0h2.2s0,0,0,0h.7c0,0,0,0,.1,0l3.5,2.1c0,0,.1.1.1.2v1c0,.1-.1.2-.2.2Z" />
      <path class="st10"
            d="M266,119c-.1,0-.2-.1-.2-.2v-.9l-3.3-2h-.7s-2.2,0-2.2,0h-.7s-3.3,2-3.3,2v.9c0,.1-.1.2-.2.2s-.2-.1-.2-.2v-1c0,0,0-.2.1-.2l3.5-2.1s0,0,.1,0h.7s0,0,0,0h2.2s0,0,0,0h.7c0,0,0,0,.1,0l3.5,2.1c0,0,.1.1.1.2v1c0,.1-.1.2-.2.2Z" />
      <path class="st10" d="M266,114.1h-10.6c-.1,0-.2-.1-.2-.2s.1-.2.2-.2h10.6c.1,0,.2.1.2.2s-.1.2-.2.2Z" />
      <path class="st10" d="M266,118h-10.5c-.1,0-.2-.1-.2-.2s.1-.2.2-.2h10.5c.1,0,.2.1.2.2s-.1.2-.2.2Z" />
      <path class="st10" d="M265.1,122.2h-8.8c-.1,0-.2-.1-.2-.2s.1-.2.2-.2h8.8c.1,0,.2.1.2.2s-.1.2-.2.2Z" />
    </g>

    <g class="verbrauch-icon">
      <path class="st9"
            d="M18.5,77.7c-.3,0-.7,0-1-.1-.6-.2-1.2-.5-1.7-1-.7-.7-1.1-1.7-1.1-2.7v-3.1c-.4,0-.7-.4-.7-.8v-.4c0-.4.3-.8.8-.8h.4v-2.6c0-.4.4-.8.8-.8s.4,0,.6.2c.2.2.2.4.2.6v2.6h3.5v-2.6c0-.4.4-.8.8-.8s.4,0,.6.2c.2.2.2.4.2.6v2.6h.5c.4,0,.8.3.8.8v.4c0,.4-.3.8-.8.8h0v3.1c0,1.7-1.2,3.2-2.8,3.7-.3,0-.7.1-1,.1ZM15.1,70.7v3.1c0,.9.3,1.7,1,2.4.4.4.9.7,1.5.9.6.2,1.2.2,1.8,0,1.4-.4,2.4-1.7,2.4-3.2v-3.1h-6.7ZM14.7,69.3c-.1,0-.3.1-.3.3v.4c0,.1.1.3.3.3h7.7c.1,0,.3-.1.3-.3v-.4c0-.1-.1-.3-.3-.3h-7.7ZM20.9,68.8h.5v-2.6c0,0,0-.2,0-.2,0,0-.1,0-.2,0-.2,0-.3.1-.3.3v2.6s0,0,.1,0ZM15.6,68.8h.5s0,0,.1,0v-2.6c0,0,0-.2,0-.2,0,0-.1,0-.2,0-.2,0-.3.1-.3.3v2.6Z" />
      <path class="st9"
            d="M19.2,80.1h-1.4c-.3,0-.5-.2-.5-.5v-2.2c0-.1.1-.3.3-.3s.3.1.3.3v2.2s0,0,0,0h1.4s0,0,0,0v-2.2c0-.1.1-.3.3-.3s.3.1.3.3v2.2c0,.3-.2.5-.5.5Z" />
      <path class="st9"
            d="M18.2,76.1s0,0,0,0c-.2,0-.3-.2-.3-.4v-1.2h-.5c-.1,0-.2,0-.3-.2,0-.1,0-.3,0-.4l1.5-2.4c0-.1.2-.2.4-.2.2,0,.3.2.3.4v1.3h.5c.1,0,.2,0,.3.2,0,.1,0,.3,0,.4l-1.5,2.4c0,.1-.2.2-.3.2ZM17.6,74.1h.4c.2,0,.4.2.4.4v.9l1.1-1.7h-.4c-.2,0-.4-.2-.4-.4v-.9l-1.1,1.8ZM19.7,73.5h0,0Z" />
    </g>

  </svg>

  <p></p>

  <!-- <h3 class="text-xl mb-4 font-semibold mt-5">Pfeilen Details</h3>
  <div class="space-y-4">
    <ul class="list-none space-y-2">
      <li class="text-lg font-bold border-b pb-2">Formel {{ arrowModelValue().option }}
        : {{ arrowModelValue().formula }}
      </li>
      <li class="text-lg font-bold border-b pb-2">
        Daten : <span class="text-sm font-bold">P:</span> {{ resource.value().production }},
        <span class="text-sm font-bold">V:</span> {{ resource.value().consumption }},
        <span class="text-sm font-bold">B:</span> {{ resource.value().batteryStatusKwh }},
        <span class="text-sm font-bold">N:</span> {{ resource.value().grid }}
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">1</span>
        <strong class="flex-1">Produktion zu Verbrauch:</strong>
        {{ arrowModelValue().production_to_consumption }}
        ({{ arrowModelValue().production_to_consumption | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">2</span>
        <strong class="flex-1">Produktion zu Batterie:</strong>
        {{ arrowModelValue().production_to_battery }}
        ({{ arrowModelValue().production_to_battery | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">3</span>
        <strong class="flex-1">Produktion zu Netz:</strong>
        {{ arrowModelValue().production_to_grid }}
        ({{ arrowModelValue().production_to_grid | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">4</span>
        <strong class="flex-1">Verbrauch zu Batterie:</strong>
        {{ arrowModelValue().consumption_to_battery }}
        ({{ arrowModelValue().consumption_to_battery | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">5</span>
        <strong class="flex-1">Netz zu Batterie:</strong>
        {{ arrowModelValue().grid_to_battery }}
        ({{ arrowModelValue().grid_to_battery | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">6</span>
        <strong class="flex-1">Netz zu Verbrauch:</strong>
        {{ arrowModelValue().grid_to_consumption }}
        ({{ arrowModelValue().grid_to_consumption | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">-6</span>
        <strong class="flex-1">Verbrauch zu Netz:</strong>
        {{ arrowModelValue().consumption_to_grid }}
        ({{ arrowModelValue().consumption_to_grid | percentage }})
      </li>
      <li class="flex items-center border-b pb-2">
        <span class="mr-2 text-gray-500">-5</span>
        <strong class="flex-1">Batterie zu Netz:</strong>
        {{ arrowModelValue().battery_to_grid }}
        ({{ arrowModelValue().battery_to_grid | percentage }})
      </li>
      <li class="flex items-center pb-2">
        <span class="mr-2 text-gray-500">-4</span>
        <strong class="flex-1">Batterie zu Verbrauch:</strong>
        {{ arrowModelValue().battery_to_consumption }}
        ({{ arrowModelValue().battery_to_consumption | percentage }})
      </li>

    </ul>
  </div>-->

</div>
